// DS: i9.8
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Receipt: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.78008 3.00004L19.5 3C19.7762 3 20 3.22386 20 3.5L20 19.8099C20 19.9324 19.955 20.0506 19.8737 20.1421L19.2603 20.8322C19.1654 20.9389 19.0294 21 18.8866 21H16.1667C16.0585 21 15.9532 20.9649 15.8667 20.9L14.9875 20.2406C14.8 20.1 14.54 20.1085 14.3621 20.261L13.6404 20.8796C13.5498 20.9573 13.4345 21 13.3151 21H10.6848C10.5655 21 10.4502 20.9573 10.3596 20.8796L9.63782 20.261C9.45989 20.1085 9.1999 20.1 9.01242 20.2407L8.13334 20.9C8.04679 20.9649 7.94152 21 7.83333 21H5.20711C5.0745 21 4.94732 20.9473 4.85355 20.8536L4.14645 20.1464C4.05268 20.0527 4 19.923 4 19.7904L4.00003 7.19256C4.00004 7.0701 4.04497 6.94944 4.12633 6.85792L7.40638 3.16786C7.50126 3.06111 7.63726 3.00004 7.78008 3.00004ZM8 8H16V10H8V8ZM14 12H8V14H14V12Z"
        />
      </svg>
    </IconWrap>
  );
};
Receipt.displayName = 'Receipt';

export default Receipt;
